import React, { useState } from 'react';
import { Badge, IconButton, Tooltip } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useOverstayNotifications } from 'containers/pages/CANpark/hooks/useOverstayNotifications';
import OverstayNotificationDrawer from './OverstayNotificationDrawer';

const OverstayNotificationBell: React.FC = () => {
	const [open, setOpen] = useState(false);
	const {
		overstays,
		dismiss,
		dismissAll,
		getParkingLocation,
	} = useOverstayNotifications();

	return (
		<>
			<Tooltip title="CANpark Notifications">
				<IconButton
					size="large"
					aria-label="canpark notifications"
					onClick={() => setOpen(true)}
					color="inherit"
				>
					<Badge
						badgeContent={overstays.length}
						color="error"
						invisible={overstays.length === 0}
					>
						<NotificationsIcon />
					</Badge>
				</IconButton>
			</Tooltip>
			<OverstayNotificationDrawer
				open={open}
				onClose={() => setOpen(false)}
				overstays={overstays}
				dismiss={dismiss}
				dismissAll={dismissAll}
				getParkingLocation={getParkingLocation}
			/>
		</>
	);
};

export default OverstayNotificationBell;
